import React from 'react';
import { Spinner } from 'react-bootstrap';

interface SpinnerOverlayProps {
    show: boolean;
}
function SpinnerOverlay({ show }: SpinnerOverlayProps) {
    if (!show) return null;
    return (
        <div className="spinner-overlay">
            <div className="content">
                <Spinner animation="border" />
            </div>
        </div>
    );
}

export { SpinnerOverlay };
